export default __webpack_public_path__ + "static/golden_opportunity_bg-f0334a31846a2e7c880db4ea51a952c6.jpg";